const effects = (dispatch) => ({});

export default effects;
